import { ORDER_METHODS, RoomServiceLocationType } from '../../../../../../services/exports/Constants';

export default {
  title: {
    [ORDER_METHODS.DELIVERY]: 'Toimitus',
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Huonepalvelu',
      [RoomServiceLocationType.TableService]: 'Pöytäpalvelu',
    },
  },
  form: {
    doorbell_name: {
      placeholder: 'Ovikellon nimi (valinnainen)',
    },
    company_name: {
      placeholder: 'Yrityksen nimi (valinnainen)',
    },
    customer_note: {
      placeholder: 'Toimitusohjeet (valinnainen)',
    },
    order_instructions: {
      placeholder: 'Kirjoita tilausohjeet...',
    },
  },
};
